const $inject = ['$http', '$q', 'apiService'];

const userContactService = ($http, $q, apiService) => {
  return {
    send: send
  };

  function send(message) {
    const deferred = $q.defer();

    const apiUrl = apiService.getUrl('userContact', { message: message });

    $http.post(apiUrl).then(() => {
      deferred.resolve();
    }, () => {
      deferred.reject();
    });

    return deferred.promise;
  }
};

userContactService.$inject = $inject;

export default userContactService;


// WEBPACK FOOTER //
// ./src/services/userContactService.js